"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VolumeData = void 0;
const angular_1 = __importDefault(require("angular"));
class VolumeAnalyser {
    constructor(source, analyser) {
        this.source = source;
        this.analyser = analyser;
        this.MINIMAL_NOISE_TRESHOLD = 8;
    }
    connectSourceToAnalyser() {
        this.source.connect(this.analyser);
    }
    disconnectSourceFromAnalyser() {
        this.source.disconnect(this.analyser);
    }
    getVolumeData() {
        let byteFrequencies = new Uint8Array(this.analyser.frequencyBinCount);
        this.analyser.getByteFrequencyData(byteFrequencies);
        let totalVolume = 0;
        for (let i = 0; i < byteFrequencies.length; i++) {
            totalVolume += Math.pow(byteFrequencies[i], 2);
        }
        let average = Math.sqrt(totalVolume / byteFrequencies.length);
        if (average > this.MINIMAL_NOISE_TRESHOLD)
            return average;
        else
            return 0;
    }
}
class MonitoredCall {
    constructor(sipCallId, audioContext) {
        this.sipCallId = sipCallId;
        this.audioContext = audioContext;
    }
    startInputAnalyser() {
        this.inputVolumeAnalyser.connectSourceToAnalyser();
    }
    startOutputAnalyser() {
        this.outputVolumeAnalyser.connectSourceToAnalyser();
    }
}
class VolumeData {
    constructor(sipCallId, volume) {
        this.sipCallId = sipCallId;
        this.volume = volume;
    }
}
exports.VolumeData = VolumeData;
class ProcessVolume {
    constructor($interval, $rootScope, $timeout, $window) {
        this.$interval = $interval;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$window = $window;
        this.MICROPHONE_ACTIVITY_TIMEOUT_MS = 5000;
        this.PROCESS_AUDIO_INTERVAL_MS = 100;
        this.EVENT_OUTPUT_VOLUME = 'OutputVolumeUpdate';
        this.EVENT_INPUT_VOLUME = 'InputVolumeUpdate';
        this.EVENT_INPUT_ACTIVE = 'AudioInputActive';
        this.monitoredCalls = [];
        this.microphoneIsActive = false;
        this.microphoneActivityTimeout = undefined;
        this.monitorCall = (sipCallId, MonitoredCallClass = MonitoredCall) => {
            if (this.callIsAlreadyMonitored(sipCallId))
                return;
            else {
                let monitoredCall = this.createMonitoredCall(sipCallId, MonitoredCallClass);
                this.monitoredCalls.push(monitoredCall);
                monitoredCall.destroyLocalStreamhandler = this.$window.xc_webrtc.setLocalStreamHandler(this.onLocalStream.bind(null, sipCallId), sipCallId);
                monitoredCall.destroyRemoteStreamhandler = this.$window.xc_webrtc.setRemoteStreamHandler(this.onRemoteStream.bind(null, sipCallId), sipCallId);
                monitoredCall.destroyAudioInterval = this.$interval(this.processAudio.bind(null, sipCallId), this.PROCESS_AUDIO_INTERVAL_MS);
            }
        };
        this.callIsAlreadyMonitored = (sipCallId) => {
            if (this.monitoredCalls.length > 0) {
                return this.monitoredCalls
                    .find(_ => _.sipCallId == sipCallId);
            }
            else
                return false;
        };
        this.createAnalyser = (source, analyser) => {
            return new VolumeAnalyser(source, analyser);
        };
        this.onMicChange = (stream) => {
            this.monitoredCalls.forEach(monitoredCall => {
                monitoredCall.inputVolumeAnalyser.disconnectSourceFromAnalyser();
                monitoredCall.inputVolumeAnalyser = this.createAnalyser(monitoredCall.audioContext.createMediaStreamSource(stream), monitoredCall.audioContext.createAnalyser());
                monitoredCall.startInputAnalyser();
            });
        };
        this.onLocalStream = (sipCallId, localStream) => {
            let monitoredCall = this.monitoredCalls.find(_ => _.sipCallId == sipCallId);
            monitoredCall.inputVolumeAnalyser = this.createAnalyser(monitoredCall.audioContext.createMediaStreamSource(localStream), monitoredCall.audioContext.createAnalyser());
            monitoredCall.startInputAnalyser();
        };
        this.onRemoteStream = (sipCallId, remoteStream) => {
            let monitoredCall = this.monitoredCalls.find(_ => _.sipCallId == sipCallId);
            monitoredCall.outputVolumeAnalyser = this.createAnalyser(monitoredCall.audioContext.createMediaStreamSource(remoteStream), monitoredCall.audioContext.createAnalyser());
            monitoredCall.startOutputAnalyser();
        };
        this.createMonitoredCall = (sipCallId, MonitoredCallClass) => {
            let audioContext = this.$window.xc_webrtc.getAudioContext();
            let monitoredCall = new MonitoredCallClass(sipCallId, audioContext);
            return monitoredCall;
        };
        this.unmonitorCall = (sipCallId) => {
            this.monitoredCalls.find((monitoredCall, index) => {
                if (monitoredCall
                    && monitoredCall.sipCallId == sipCallId
                    && monitoredCall.inputVolumeAnalyser
                    && monitoredCall.outputVolumeAnalyser) {
                    monitoredCall.inputVolumeAnalyser.disconnectSourceFromAnalyser();
                    monitoredCall.outputVolumeAnalyser.disconnectSourceFromAnalyser();
                    monitoredCall.destroyLocalStreamhandler();
                    monitoredCall.destroyRemoteStreamhandler();
                    if (angular_1.default.isDefined(this.microphoneActivityTimeout)) {
                        this.$timeout.cancel(this.microphoneActivityTimeout);
                        this.microphoneActivityTimeout = undefined;
                    }
                    if (angular_1.default.isDefined(monitoredCall.destroyAudioInterval))
                        this.$interval.cancel(monitoredCall.destroyAudioInterval);
                    this.monitoredCalls.splice(index, 1);
                }
            });
            if (this.monitoredCalls.length == 0) {
                this.$timeout.cancel(this.microphoneActivityTimeout);
            }
        };
        this.processAudio = (sipCallId) => {
            let monitoredCall = this.monitoredCalls.find(m => m.sipCallId == sipCallId);
            if (monitoredCall) {
                if (monitoredCall.outputVolumeAnalyser) {
                    this.$rootScope.$broadcast(this.EVENT_OUTPUT_VOLUME, new VolumeData(sipCallId, monitoredCall.outputVolumeAnalyser.getVolumeData()));
                }
                if (monitoredCall.inputVolumeAnalyser) {
                    let inputVolume = monitoredCall.inputVolumeAnalyser.getVolumeData();
                    this.checkForMicrophoneIssues(inputVolume);
                    this.$rootScope.$broadcast(this.EVENT_INPUT_VOLUME, new VolumeData(sipCallId, inputVolume));
                }
            }
        };
        this.checkForMicrophoneIssues = (inputVolume) => {
            if (inputVolume != 0) {
                if (angular_1.default.isDefined(this.microphoneActivityTimeout)) {
                    this.$timeout.cancel(this.microphoneActivityTimeout);
                    this.microphoneActivityTimeout = undefined;
                }
                if (!this.microphoneIsActive)
                    this.microphoneIsActive = true;
                this.$rootScope.$broadcast(this.EVENT_INPUT_ACTIVE, true);
            }
            else {
                if (this.microphoneActivityTimeout == undefined)
                    this.microphoneActivityTimeout = this.$timeout(this.notifyMicrophoneIssue, this.MICROPHONE_ACTIVITY_TIMEOUT_MS);
            }
        };
        this.notifyMicrophoneIssue = () => {
            if (this.monitoredCalls.length > 0) {
                this.$rootScope.$broadcast(this.EVENT_INPUT_ACTIVE, false);
                this.microphoneIsActive = false;
            }
        };
    }
}
exports.default = ProcessVolume;
